import { useState, useMemo } from "react";

const allCities = [
  { name: "Kansas City", route: "#", tagline: "Western Missouri expedited passport services", highlights: ["Jackson County coverage", "Serving Overland Park, Independence, Lee's Summit"], badge: "Most Popular", status: "coming" },
  { name: "St. Louis", route: "#", tagline: "Eastern Missouri trusted passport processing", highlights: ["St. Louis County coverage", "Serving Chesterfield, Florissant, Kirkwood"], badge: "Most Popular", status: "coming" },
  { name: "Springfield", route: "#", tagline: "Southwest Missouri passport courier service", highlights: ["Greene County coverage", "Serving Nixa, Ozark, Republic"], badge: null, status: "coming" },
  { name: "Columbia", route: "#", tagline: "Central Missouri expedited passport services", highlights: ["Boone County coverage", "Serving Jefferson City, Moberly"], badge: null, status: "coming" },
  { name: "Independence", route: "#", tagline: "Kansas City metro area passport processing", highlights: ["Jackson County coverage", "Serving Blue Springs, Grain Valley"], badge: null, status: "coming" },
  { name: "Lee's Summit", route: "#", tagline: "Kansas City suburbs expedited passports", highlights: ["Jackson County coverage", "Serving Raytown, Grandview"], badge: null, status: "coming" },
  { name: "O'Fallon", route: "#", tagline: "St. Charles County passport services", highlights: ["St. Charles County coverage", "Serving Lake Saint Louis, Wentzville"], badge: null, status: "coming" },
  { name: "St. Joseph", route: "#", tagline: "Northwest Missouri passport processing", highlights: ["Buchanan County coverage", "Serving Savannah, Dearborn"], badge: null, status: "coming" },
  { name: "St. Charles", route: "#", tagline: "St. Charles County expedited passport hub", highlights: ["Historic St. Charles area", "Serving O'Fallon, Weldon Spring"], badge: null, status: "coming" },
  { name: "Blue Springs", route: "#", tagline: "Eastern Jackson County passport services", highlights: ["Blue Springs area coverage", "Serving Grain Valley, Oak Grove"], badge: null, status: "coming" },
  { name: "Joplin", route: "#", tagline: "Southwest Missouri border passport processing", highlights: ["Jasper County coverage", "Serving Webb City, Carthage"], badge: null, status: "coming" },
  { name: "Jefferson City", route: "#", tagline: "State capital expedited passport services", highlights: ["Cole County coverage", "Serving Columbia, California"], badge: null, status: "coming" },
  { name: "Cape Girardeau", route: "#", tagline: "Southeast Missouri passport services", highlights: ["Cape Girardeau County coverage", "Serving Jackson, Perryville"], badge: null, status: "coming" },
  { name: "Florissant", route: "#", tagline: "North St. Louis County passport processing", highlights: ["St. Louis County coverage", "Serving Hazelwood, Ferguson"], badge: null, status: "coming" },
  { name: "Chesterfield", route: "#", tagline: "West St. Louis County expedited passports", highlights: ["Chesterfield area coverage", "Serving Ballwin, Wildwood"], badge: null, status: "coming" },
  { name: "Wentzville", route: "#", tagline: "Western St. Charles County passport services", highlights: ["Wentzville area coverage", "Serving Lake Saint Louis, Troy"], badge: null, status: "coming" },
  { name: "Ballwin", route: "#", tagline: "West St. Louis County passport processing", highlights: ["Ballwin area coverage", "Serving Ellisville, Manchester"], badge: null, status: "coming" },
  { name: "Liberty", route: "#", tagline: "Clay County expedited passport services", highlights: ["Clay County coverage", "Serving Kearney, Smithville"], badge: null, status: "coming" },
  { name: "Raytown", route: "#", tagline: "Eastern Jackson County passport processing", highlights: ["Raytown area coverage", "Serving Kansas City, Independence"], badge: null, status: "coming" },
  { name: "Kirkwood", route: "#", tagline: "Southwest St. Louis County passport services", highlights: ["Kirkwood area coverage", "Serving Des Peres, Webster Groves"], badge: null, status: "coming" },
  { name: "Gladstone", route: "#", tagline: "North Kansas City metro passport processing", highlights: ["Gladstone area coverage", "Serving North Kansas City, Parkville"], badge: null, status: "coming" },
  { name: "Grandview", route: "#", tagline: "Southern Jackson County passport services", highlights: ["Grandview area coverage", "Serving Belton, Raymore"], badge: null, status: "coming" },
  { name: "Belton", route: "#", tagline: "South Kansas City metro passport processing", highlights: ["Belton area coverage", "Serving Raymore, Peculiar"], badge: null, status: "coming" },
  { name: "Nixa", route: "#", tagline: "Christian County expedited passport services", highlights: ["Nixa area coverage", "Serving Ozark, Clever"], badge: null, status: "coming" },
  { name: "Ozark", route: "#", tagline: "Christian County passport processing", highlights: ["Ozark area coverage", "Serving Nixa, Sparta"], badge: null, status: "coming" },
  { name: "Warrensburg", route: "#", tagline: "Johnson County passport services", highlights: ["University of Central Missouri area", "Serving Knob Noster, Holden"], badge: null, status: "coming" },
  { name: "Rolla", route: "#", tagline: "Phelps County expedited passport processing", highlights: ["Missouri S&T area", "Serving St. James, Newburg"], badge: null, status: "coming" },
  { name: "Sedalia", route: "#", tagline: "Pettis County passport services", highlights: ["Sedalia area coverage", "Serving Whiteman AFB, Green Ridge"], badge: null, status: "coming" },
  { name: "Hannibal", route: "#", tagline: "Northeast Missouri passport processing", highlights: ["Marion County coverage", "Serving Palmyra, Monroe City"], badge: null, status: "coming" },
  { name: "Kirksville", route: "#", tagline: "Northeast Missouri expedited passports", highlights: ["Truman State University area", "Serving La Plata, Edina"], badge: null, status: "coming" },
  { name: "Sikeston", route: "#", tagline: "Southeast Missouri passport services", highlights: ["Scott County coverage", "Serving Cape Girardeau, Charleston"], badge: null, status: "coming" },
  { name: "Poplar Bluff", route: "#", tagline: "Butler County passport processing", highlights: ["Poplar Bluff area coverage", "Serving Dexter, Doniphan"], badge: null, status: "coming" },
  { name: "Lebanon", route: "#", tagline: "Laclede County expedited passport services", highlights: ["Lebanon area coverage", "Serving Waynesville, Richland"], badge: null, status: "coming" },
  { name: "Fulton", route: "#", tagline: "Callaway County passport processing", highlights: ["Westminster College area", "Serving Columbia, New Bloomfield"], badge: null, status: "coming" },
];

const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

export default function MissouriCitiesDirectory() {
  const [activeLetter, setActiveLetter] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState("");

  const lettersWithCities = useMemo(() => {
    const set = new Set<string>();
    allCities.forEach((c) => set.add(c.name[0].toUpperCase()));
    return set;
  }, []);

  const filteredCities = useMemo(() => {
    let result = allCities;
    if (activeLetter) {
      result = result.filter((c) => c.name[0].toUpperCase() === activeLetter);
    }
    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase();
      result = result.filter(
        (c) =>
          c.name.toLowerCase().includes(q) ||
          c.tagline.toLowerCase().includes(q) ||
          c.highlights.some((h) => h.toLowerCase().includes(q))
      );
    }
    return result;
  }, [activeLetter, searchQuery]);

  const liveCount = allCities.filter((c) => c.status === "live").length;
  const comingCount = allCities.filter((c) => c.status === "coming").length;

  return (
    <section id="cities" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">
            Missouri Cities
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Choose Your Missouri Location
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed mb-2">
            Select your city to view local acceptance facilities, processing options, and
            expedited services tailored to your area.
          </p>
          <p className="text-gray-400 text-sm">
            <span className="text-[#1A365D] font-semibold">{liveCount}</span> cities live
            &nbsp;&middot;&nbsp;
            <span className="text-[#1A365D] font-semibold">{comingCount}</span> more coming
            soon
          </p>
        </div>

        {/* Search bar */}
        <div className="max-w-xl mx-auto mb-6">
          <div className="relative">
            <div className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center">
              <i className="ri-search-line text-gray-400"></i>
            </div>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                if (e.target.value.trim() && activeLetter) setActiveLetter(null);
              }}
              placeholder="Search cities..."
              className="w-full pl-11 pr-10 py-3 bg-white border border-gray-200 rounded-lg text-sm text-[#1A365D] placeholder:text-gray-400 focus:outline-none focus:border-[#F6C344] focus:ring-1 focus:ring-[#F6C344] transition-all"
            />
            {searchQuery && (
              <button
                onClick={() => setSearchQuery("")}
                className="absolute right-3 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center text-gray-400 hover:text-gray-600"
              >
                <i className="ri-close-line"></i>
              </button>
            )}
          </div>
        </div>

        {/* Alphabet bar */}
        <div className="max-w-4xl mx-auto mb-12">
          <div className="flex flex-wrap items-center justify-center gap-1.5 md:gap-2">
            <button
              onClick={() => setActiveLetter(null)}
              className={`px-3 py-1.5 rounded-md text-sm font-semibold transition-all whitespace-nowrap ${
                activeLetter === null
                  ? "bg-[#1A365D] text-white"
                  : "bg-white text-gray-500 hover:bg-[#EEF2F8] hover:text-[#1A365D] border border-gray-200"
              }`}
            >
              All
            </button>
            {LETTERS.map((letter) => {
              const hasCities = lettersWithCities.has(letter);
              const isActive = activeLetter === letter;
              return (
                <button
                  key={letter}
                  onClick={() => hasCities && setActiveLetter(isActive ? null : letter)}
                  disabled={!hasCities}
                  className={`w-8 h-8 md:w-9 md:h-9 rounded-md text-sm font-semibold flex items-center justify-center transition-all ${
                    isActive
                      ? "bg-[#1A365D] text-white"
                      : hasCities
                        ? "bg-white text-[#1A365D] hover:bg-[#EEF2F8] border border-gray-200 cursor-pointer"
                        : "bg-gray-100 text-gray-300 border border-gray-100 cursor-not-allowed"
                  }`}
                >
                  {letter}
                </button>
              );
            })}
          </div>
        </div>

        {/* Results count */}
        {(activeLetter || searchQuery) && (
          <div className="flex items-center justify-between max-w-7xl mb-6">
            <p className="text-sm text-gray-500">
              Showing{" "}
              <span className="font-semibold text-[#1A365D]">{filteredCities.length}</span>{" "}
              {filteredCities.length === 1 ? "city" : "cities"}
              {activeLetter && (
                <>
                  {" "}
                  starting with <span className="font-semibold text-[#1A365D]">{activeLetter}</span>
                </>
              )}
              {searchQuery && (
                <>
                  {" "}
                  matching <span className="font-semibold text-[#1A365D]">"{searchQuery}"</span>
                </>
              )}
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="text-sm text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors whitespace-nowrap"
            >
              Clear filters
            </button>
          </div>
        )}

        {/* City cards grid */}
        {filteredCities.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredCities.map((city, i) =>
              city.status === "live" ? (
                <a
                  key={i}
                  href={city.route}
                  className="group relative bg-white border border-gray-200 rounded-lg p-7 hover:border-[#F6C344] transition-all duration-200 flex flex-col"
                >
                  {city.badge && (
                    <span className="absolute top-4 right-4 bg-[#1A365D] text-white text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                      {city.badge}
                    </span>
                  )}
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                      <i className="ri-map-pin-2-line text-[#1A365D] text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-[#1A365D] text-lg">{city.name}</h3>
                      <p className="text-gray-400 text-xs">Missouri</p>
                    </div>
                  </div>
                  <p className="text-gray-500 text-sm leading-relaxed mb-4">{city.tagline}</p>
                  <ul className="space-y-2 mb-6 flex-1">
                    {city.highlights.map((h, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-600">
                        <i className="ri-check-line text-[#F6C344] flex-shrink-0"></i>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center gap-1.5 text-[#1A365D] font-semibold text-sm group-hover:text-[#F6C344] transition-colors mt-auto whitespace-nowrap">
                    View Services{" "}
                    <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
                  </div>
                </a>
              ) : (
                <div
                  key={i}
                  className="group relative bg-white border border-dashed border-gray-300 rounded-lg p-7 flex flex-col"
                >
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gray-100 flex-shrink-0">
                      <i className="ri-time-line text-gray-400 text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-400 text-lg">{city.name}</h3>
                      <span className="inline-block bg-gray-100 text-gray-500 text-xs font-semibold px-2 py-0.5 rounded-full mt-0.5">
                        Coming Soon
                      </span>
                    </div>
                  </div>
                  <p className="text-gray-400 text-sm leading-relaxed mb-4">{city.tagline}</p>
                  <ul className="space-y-2 mb-6 flex-1">
                    {city.highlights.map((h, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-400">
                        <i className="ri-check-line text-gray-300 flex-shrink-0"></i>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center gap-1.5 text-gray-400 font-semibold text-sm mt-auto whitespace-nowrap">
                    Coming Soon <i className="ri-time-line"></i>
                  </div>
                </div>
              )
            )}
          </div>
        ) : (
          <div className="text-center py-16">
            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#EEF2F8] mx-auto mb-4">
              <i className="ri-search-line text-[#1A365D] text-2xl"></i>
            </div>
            <h3 className="font-bold text-[#1A365D] text-lg mb-2">No cities found</h3>
            <p className="text-gray-500 text-sm max-w-md mx-auto">
              Try a different search term or letter. We're always adding new Missouri locations.
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="mt-4 inline-flex items-center gap-1.5 text-[#1A365D] hover:text-[#F6C344] font-semibold text-sm transition-colors whitespace-nowrap"
            >
              Show all cities <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        )}
      </div>
    </section>
  );
}